<div class="edit-form">
  <mat-card appearance="raised">
    <mat-card-content>
      @if (isNewContact == false) {
        <h3 class="update-heading"><span>Update </span>{{campusContactName}}</h3>
      }
      @if (isNewContact == true) {
        <h3>Add New Contact</h3>
      }

      @if (loadingCampusContact) {
        <div>
          <mat-spinner class="busy-spinner"></mat-spinner>
        </div>
      }

      @if (!loadingCampusContact) {
        <div>
          <form [formGroup]="contactForm" >
            <div [style.height]="formHeight" style="overflow-y: auto;">
              <mat-grid-list cols="2" rowHeight="70px" gutterSize="10px">
                <mat-grid-tile>
                  <mat-form-field>
                    <mat-label>Contact Type</mat-label>
                    <mat-select formControlName="contactTypeID" required>
                      @for (contactType of contactTypes; track contactType) {
                        <mat-option [value]="contactType.id">
                        {{contactType.description}}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </mat-grid-tile>
                <mat-grid-tile></mat-grid-tile>
              <mat-grid-tile>
                <mat-form-field>
                  <mat-label>First Name</mat-label>
                  <input matInput formControlName="firstName" required>
                </mat-form-field>
              </mat-grid-tile>
              <mat-grid-tile>
                <mat-form-field>
                  <mat-label>Last Name</mat-label>
                  <input matInput formControlName="lastName" required>
                </mat-form-field>
              </mat-grid-tile>
              <mat-grid-tile>
                <mat-form-field>
                  <mat-label>Title</mat-label>
                  <input matInput formControlName="title">
                </mat-form-field>
              </mat-grid-tile>
              <mat-grid-tile>
                @if (canUserViewMentorDetails && showMentorDetails) {
                  <mat-form-field>
                    <mat-label>State License ID</mat-label>
                    <input matInput formControlName="stateLicenseID">
                  </mat-form-field>
                }
              </mat-grid-tile>
              <mat-grid-tile>
                <mat-form-field>
                  <mat-label>Email Address</mat-label>
                  <input matInput type="email" formControlName="emailAddress" required>
                  @if (contactForm.get('emailAddress')?.hasError) {
                    <mat-error>Email Address is not valid
                    </mat-error>
                  }
                </mat-form-field>
              </mat-grid-tile>
              <mat-grid-tile>
                <mat-form-field>
                  <mat-label>Phone Number</mat-label>
                  <input matInput formControlName="phoneNumber">
                </mat-form-field>
              </mat-grid-tile>
              <mat-grid-tile>
                <div class="voe-contact-checkbox">
                  <mat-checkbox formControlName="voeContact" color="primary">
                    VOE Contact
                  </mat-checkbox>
                </div>
              </mat-grid-tile>
              <div formGroupName="mentorDetails">
                @if (canUserViewMentorDetails && showMentorDetails) {
                  <section>
                    <mat-grid-tile>
                      <mat-form-field>
                        <mat-label>Address 1</mat-label>
                        <input matInput formControlName="address1">
                      </mat-form-field>
                    </mat-grid-tile>
                    <mat-grid-tile>
                      <mat-form-field>
                        <mat-label>Address 2</mat-label>
                        <input matInput formControlName="address2">
                      </mat-form-field>
                    </mat-grid-tile>
                    <mat-grid-tile>
                      <mat-form-field>
                        <mat-label>City</mat-label>
                        <input matInput formControlName="city">
                      </mat-form-field>
                    </mat-grid-tile>
                    <mat-grid-tile>
                      <mat-form-field>
                        <mat-label>State</mat-label>
                        <mat-select class="field-input" formControlName="stateId">
                          @for (state of states; track state) {
                            <mat-option [value]="state.Id">
                              {{state.StateName}}
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    </mat-grid-tile>
                    <mat-grid-tile>
                      <mat-form-field>
                        <mat-label>Zip</mat-label>
                        <input matInput formControlName="postalCode">
                      </mat-form-field>
                    </mat-grid-tile>
                  </section>
                }
              </div>
            </mat-grid-list>
            <div class="district-access-container">
              @if (isNewContact === false && canHaveDistrictPortalAccess) {
                <fieldset class="district-access-fieldset">
                  <legend>District Portal Access</legend>
                  <mat-form-field class="company-options" [matTooltip]="selectedCompanyLabels" matTooltipShowDelay="400">
                    <mat-label>Company</mat-label>
                    <mat-select formControlName="companyIds" multiple>
                      <mat-select-trigger>{{ selectedCompanyLabels }}</mat-select-trigger>
                      @for (opt of companyOptions; track opt.value) {
                        <mat-option [value]="opt.value">{{ opt.label }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </fieldset>
              }
            </div>
            @if (canUserViewMentorDetails && showMentorDetails) {
              <div formGroupName="mentorDetails" class="mentor-documents">
                <mat-grid-list cols="2" rowHeight="70px" gutterSize="10px">
                  <mat-grid-tile>
                    <mat-form-field>
                      <mat-label>Teaching Certificate</mat-label>
                      <mat-select formControlName="teachingCertificate">
                        @for (option of options; track option) {
                          <mat-option
                            [value]="option"
                            [disabled]="!option && teachingCertificateDocumentsAvailable">
                            {{option ? 'Yes' : 'No'}}
                            @if (!option && teachingCertificateDocumentsAvailable) {
                              <span class="download-dropdown-no-disallowed">- Delete uploaded documents to select this option</span>
                            }
                          </mat-option>
                        }
                      </mat-select>
                      @if (contactForm.controls.mentorDetails.controls.teachingCertificate.errors; as errors) {
                        <mat-error
                          >
                          @if (errors.atLeastOneDocumentRequired) {
                            <span>Upload one or more
                            documents</span>
                          }
                        </mat-error>
                      }
                    </mat-form-field>
                  </mat-grid-tile>
                  <mat-grid-tile></mat-grid-tile>
                  @if (showCertificateFields) {
                    <mat-grid-tile>
                      <mat-form-field class="certificate-datepicker">
                        <mat-label>Certificate Date</mat-label>
                        <input matInput [matDatepicker]="certificateDatePicker"
                          formControlName="certificateDate">
                          <mat-datepicker-toggle matSuffix [for]="certificateDatePicker">
                          </mat-datepicker-toggle>
                          <mat-datepicker #certificateDatePicker></mat-datepicker>
                        </mat-form-field>
                      </mat-grid-tile>
                    }
                    @if (showCertificateFields) {
                      <mat-grid-tile>
                        <mat-form-field>
                          <mat-label>Certificate Area</mat-label>
                          <input matInput formControlName="certificateArea">
                        </mat-form-field>
                      </mat-grid-tile>
                    }
                  </mat-grid-list>
                  @if (showTeacherCertificateDocuments) {
                    <app-mentor-document [documentType]="documentType.TeachingCertificate"
                      [campusContactId]="campusContactId" (documentsAvailableChange)="updateTeachingCertificateValidity($event)"
                      (pendingUploadsUpdated)="onPendingUploadsUpdated($event)" (pendingUploadsComplete)="onPendingUploadsComplete($event)">
                    </app-mentor-document>
                  }
                  @if (showTeacherCertificateDocuments) {
                    <hr class="divider">
                  }
                  <mat-grid-list cols="2" rowHeight="70px" gutterSize="10px" class="proof-of-accomplishment-grid">
                    <mat-grid-tile>
                      <mat-form-field>
                        <mat-label>Proof of Accomplishment</mat-label>
                        <mat-select formControlName="letterOfRecommendation">
                          @for (option of options; track option) {
                            <mat-option
                              [value]="option"
                              [disabled]="!option && proofOfAccomplishmentDocumentsAvailable">
                              {{option ? 'Yes' : 'No'}}
                              @if (!option && proofOfAccomplishmentDocumentsAvailable) {
                                <span class="download-dropdown-no-disallowed">- Delete uploaded documents to select this option</span>
                              }
                            </mat-option>
                          }
                        </mat-select>
                        @if (contactForm.controls.mentorDetails.controls.letterOfRecommendation.errors; as errors) {
                          <mat-error
                            >
                            @if (errors.atLeastOneDocumentRequired) {
                              <span>Upload one or more
                              documents</span>
                            }
                          </mat-error>
                        }
                      </mat-form-field>
                    </mat-grid-tile>
                  </mat-grid-list>
                  @if (showProofOfAccomplishmentDocuments || profileId) {
                    <app-mentor-document
                      [documentType]="documentType.ProofOfAccomplishment"
                      [campusContactId]="campusContactId"
                      [profileId]="profileId"
                      (documentsAvailableChange)="updateProofOfAccomplishmentValidity($event)"
                      (pendingUploadsUpdated)="onPendingUploadsUpdated($event)"
                      (pendingUploadsComplete)="onPendingUploadsComplete($event)"
                      (proofOfAccomplishmentDocumentAvailable)="verifyPrincipalAttestationDocuments($event)">
                    </app-mentor-document>
                  }
                  @if (showProofOfAccomplishmentDocuments) {
                    <hr class="divider">
                  }
                  <mat-grid-list cols="2" rowHeight="60px" gutterSize="10px" class="district-training-grid">
                    <mat-grid-tile>
                      <mat-form-field>
                        <mat-label>District Training</mat-label>
                        <mat-select formControlName="districtTraining">
                          @for (option of options; track option) {
                            <mat-option
                              [value]="option"
                              [disabled]="!option && districtTrainingDocumentsAvailable">
                              {{option ? 'Yes' : 'No'}}
                              @if (!option && districtTrainingDocumentsAvailable) {
                                <span class="download-dropdown-no-disallowed">- Delete uploaded documents to select this option</span>
                              }
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    </mat-grid-tile>
                    @if (showProvidedByField && hasDistrictTraining) {
                      <mat-grid-tile>
                        <mat-form-field>
                          <mat-label>Provided By</mat-label>
                          <input matInput formControlName="providedBy">
                        </mat-form-field>
                      </mat-grid-tile>
                    }
                    @if (!showProvidedByField && hasDistrictTraining) {
                      <mat-grid-tile>
                        <mat-form-field>
                          <mat-label>ToT Training Sent</mat-label>
                          <mat-select formControlName="totTrainingSent">
                            @for (option of options; track option) {
                              <mat-option [value]="option">
                                {{option ? 'Yes' : 'No'}}
                              </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      </mat-grid-tile>
                    }
                  </mat-grid-list>
                  @if (showDistrictTrainingDocuments) {
                    <app-mentor-document [documentType]="documentType.DistrictTraining"
                      [campusContactId]="campusContactId"
                      (documentsAvailableChange)="updateDistrictTrainingDocumentsAvailability($event)"
                      (pendingUploadsUpdated)="onPendingUploadsUpdated($event)" (pendingUploadsComplete)="onPendingUploadsComplete($event)">
                    </app-mentor-document>
                  }
                </div>
              }
            </div>
            <div class="form-buttons">
              @if (showWarningForRemovingAccessForDistrictPortal) {
                <div class="warningMessage">
                  Warning: You are about to remove access to the district portal for this user for {{ removedCompanyLabels }}.
                </div>
              }
              @if (showSpinner) {
                <mat-progress-bar mode="indeterminate"></mat-progress-bar>
              }
              <button mat-button mat-raised-button color="primary"
                [disabled]="!contactForm.valid" (click)="saveEdit()">
                Save
              </button>
              <button mat-button mat-raised-button color="warn" (click)="close()">Cancel</button>
            </div>
          </form>
        </div>
      }
    </mat-card-content>
  </mat-card>
</div>
